module.exports = __webpack_public_path__ + "img/upload-img.46d98adf.svg";